// src/Services/ManagerServices/ManagerReportService.js
import axiosInstance from "api/axiosInstance";
import API from "api/endpoints";

const ManagerReportService = {
  getMyDepartment: async () => {
    try {
      const response = await axiosInstance.get(API.department.myDepartment);
      return response;
    } catch (error) {
      console.error("Error in getMyDepartment:", error);
      throw error;
    }
  },

  getExpenseReport: async (departmentId = 1, periodType = null, referenceDate = null) => {
    const endpointUrl = API.reports.getExpenseReport(departmentId, periodType, referenceDate);
    return axiosInstance.get(endpointUrl);
  },

  getAttendanceReport: async (departmentId = 1, month = null, year = null) => {
    const endpointUrl = API.reports.getAttendanceReport(departmentId, month, year);
    return axiosInstance.get(endpointUrl);
  },

  getLeaveReport: async (departmentId = 1, month = null, year = null) => {
    try {
      const endpointUrl = API.reports.leaveRequestReport(departmentId, month, year);
      return await axiosInstance.get(endpointUrl);
    } catch (error) {
      console.error("Error in getLeaveReport:", error);
      throw error;
    }
  },
};

export default ManagerReportService;
